// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__y_WiI","card":"styles_card__Ei63q","buttonContainer":"styles_buttonContainer__MQP0A","button":"styles_button__hHKKZ"};